import React from 'react'
import { Grid, Row, Col, Placeholder, Panel } from 'rsuite'

export default function RiskAssessmentView(props) {
  const { Graph } = Placeholder
  const { schema } = props
  const paragraph = <>&nbsp; &nbsp; &nbsp;</>
  const emptyData = (
    <>
      <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
      <Graph height={9} />
      <Graph height={9} />
      <Graph height={9} />
    </>
  )

  return (
    <Panel bodyFill>
      <Grid fluid>
        <Row>
          <Col style={{ marginTop: 5 }}>
            <b>{schema.delayRisk.label}</b>
            {schema.isDelayEvaluated.value == 1 ? (
              <>
                {schema.delayRisk.value ? (
                  // <p>
                  //   {paragraph}
                  //   {schema.delayRisk.value}
                  // </p>
                  <div
                    style={{ paddingLeft: 15 }}
                    dangerouslySetInnerHTML={{ __html: `${schema.delayRisk.value}` }}
                  />
                ) : (
                  emptyData
                )}
              </>
            ) : (
              <p>
                {paragraph}
                {schema.isDelayEvaluated.options.map((item) => {
                  if (item.value == schema.isDelayEvaluated.value) {
                    return item.label
                  }
                })}
              </p>
            )}
          </Col>
          <Col style={{ marginTop: 5 }}>
            <b>{schema.financialRisk.label}</b>
            {schema.isFinanceEvaluated.value == 1 ? (
              <>
                {schema.financialRisk.value ? (
                  // <p>
                  //   {paragraph}
                  //   {schema.financialRisk.value}
                  // </p>
                  <div
                    style={{ paddingLeft: 15 }}
                    dangerouslySetInnerHTML={{ __html: `${schema.financialRisk.value}` }}
                  />
                ) : (
                  emptyData
                )}
              </>
            ) : (
              <p>
                {paragraph}
                {schema.isFinanceEvaluated.options.map((item) => {
                  if (item.value == schema.isFinanceEvaluated.value) {
                    return item.label
                  }
                })}
              </p>
            )}
          </Col>
        </Row>
      </Grid>
    </Panel>
  )
}
